import { Component, OnInit } from '@angular/core';
import { ResidentialStatusService } from '../residential-status.service';
import { ResidentialStatus } from '../residential-status';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-residential-status-create',
  templateUrl: 'create.component.html',
})
export class ResidentialStatusCreateComponent implements OnInit {
  /**
   * Details of the residentialStatus being created.
   */
  public residentialStatus: ResidentialStatus;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ResidentialStatusService} residentialStatusService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private residentialStatusService: ResidentialStatusService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.residentialStatusService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank residentialStatus if required.
   */
  public ngOnInit(): void {
    if (!this.residentialStatus) {
      this.residentialStatus = new ResidentialStatus();
    }
  }

  /**
   * Perform the create action which adds the new residentialStatus into the backend.
   */
  public create() {
    const createResidentialStatus = this.residentialStatusService
      .createResidentialStatus(this.residentialStatus)
      .subscribe(
        (result: ResidentialStatus) => {
          this.notificationService.success(
            `ResidentialStatus Created`,
            `New residentialStatus ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.residentialStatus = new ResidentialStatus();
          createResidentialStatus.unsubscribe();
          this.router.navigate(['/residential-statuses']);
        },
        err => {
          this.notificationService.error(
            `Could not create ResidentialStatus`,
            err.error.message,
            10,
          );
        },
      );
  }
}
